import React from "react";
import "../NotFound/NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-wrapper">
      <div className="notfound-content">
        <p className="notfound-code">404</p>
        <h1 className="notfound-title">Page not found</h1>
        <p className="notfound-description">
          Sorry, we couldn't find the page you're looking for.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
